export const columnsToggleSelector = ({ columnsToggle }) => columnsToggle;
